import _ from 'lodash'
import { PROCESS_UPDATE, PROCESS_SET_PROGRESS } from '../constants'

// Initial state of the store
const initialState = {}
// Sample state:
// {
//     tq: {
//         ccp_rubik: {
//             isRunning: false,
//             progress: 0,
//             progressName: '',
//         },
//     },
// }

const progressStates = {
    0: 'notStarted',
    1: 'clientPorcessStarted',
    10: 'clientAuthorizing',
    50: 'clientAuthorizationFailed',
    60: 'clientRefresh',
    70: 'clientRefresh',
    80: 'clientAuthorizing',
    100: 'clientStarting',
}

// Commands for the state machine
const processes = (state = initialState, action) => {
    switch (action.type) {
        // Update the process running status for a given user
        case PROCESS_UPDATE: {
            const clone = _.cloneDeep(state)
            const { server, user, isRunning } = action.payload

            // If server is missing, add it
            if (clone[server] === undefined) {
                clone[server] = {}
            }

            // If user is missing add it
            if (clone[server][user] === undefined) {
                clone[server][user] = {
                    isRunning,
                    progress: 0,
                    progressName: progressStates[0],
                }

            // User is not missing, update it
            } else {
                clone[server][user].isRunning = isRunning
            }

            return clone
        }

        // Update the progress of launching the client for a given user
        case PROCESS_SET_PROGRESS: {
            const clone = _.cloneDeep(state)
            const { server, user, progress } = action.payload

            // If server is missing, add it
            if (clone[server] === undefined) {
                clone[server] = {}
            }

            // If user is missing add it
            if (clone[server][user] === undefined) {
                clone[server][user] = {
                    isRunning: false,
                    progress,
                    progressName: progressStates[progress] || progressStates[0],
                }

            // User is not missing, update it
            } else {
                clone[server][user].progress = progress
                clone[server][user].progressName = progressStates[progress]
            }
            return clone
        }

        // Default state
        default:
            return state
    }
}

export default processes



// WEBPACK FOOTER //
// ./src/reducers/process.js